import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { Icon } from "@paclife/plds.icon";
import { Colors, Spacing } from "@paclife/plds.tokens";

import Typography from "common/Typography/Typography";

const List = styled.ul`
    padding: 0 ${Spacing[16]};
`;

const ListItem = styled.li`
    display: flex;
    align-items: center;
    margin-bottom: ${Spacing[8]};
    .left-spacing {
        margin-left: ${Spacing[4]};
    }
`;

const Title = styled(Typography)`
    margin-bottom: ${Spacing[8]};
`;

const PwdValidation = ({ value, userInfo }) => {
    const { t } = useTranslation("password");
    /** Should verify this regex fit with okta rules */
    const usernameReg = new RegExp(userInfo.username, "igm");
    const firstNameReg = new RegExp(userInfo.firstName, "igm");
    const lastNameReg = new RegExp(userInfo.lastName, "igm");

    const criteria = [
        {
            id: "minChar",
            msg: t("rules.minChar"),
            isValid: value.length >= 8
        },
        {
            id: "lowerCase",
            msg: t("rules.lowerCase"),
            isValid: /[a-z]/g.test(value)
        },
        {
            id: "upperCase",
            msg: t("rules.upperCase"),
            isValid: /[A-Z]/g.test(value)
        },
        {
            id: "number",
            msg: t("rules.number"),
            isValid: /\d/g.test(value)
        },
        {
            id: "symbol",
            msg: t("rules.symbol"),
            isValid: /[|\\/~^:,;?!&%$@*+]/g.test(value)
        },
        {
            id: "noUname",
            msg: t("rules.noUname"),
            isValid: !usernameReg.test(value)
        },
        {
            id: "noFirstName",
            msg: t("rules.noFirstName"),
            isValid: !firstNameReg.test(value)
        },
        {
            id: "noLastName",
            msg: t("rules.noLastName"),
            isValid: !lastNameReg.test(value)
        },
        {
            id: "noWhiteSpace",
            msg: "Does not include white space",
            isValid: !/\s/g.test(value)
        }
    ];

    return (
        <List>
            <Title variant='h3' display='block'>
                {t("rules.title")}
            </Title>
            {criteria.map(({ id, msg, isValid }) => (
                <ListItem key={id}>
                    {value === "" && "\u2022"}
                    {value !== "" && (
                        <Icon
                            width={16}
                            name={isValid ? "checkmarkOutline" : "alert"}
                            color={isValid ? Colors.green600 : Colors.red600}
                        />
                    )}
                    <Typography className="left-spacing">{msg}</Typography>
                </ListItem>
            ))}
        </List>
    );
};

export default PwdValidation;
